import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";

import { MS_IN } from "@repo/helpers";

import { Dev } from "./main.dev";
import { Leads } from "./pages/leads/page";
import { Auth } from "./pages/login/auth";
import { Maps } from "./pages/maps";

const rootElement = document.getElementById("root");

function App(props: Props) {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				retry: false,
				staleTime: MS_IN.MINUTE * 15,
			},
		},
	});

	return (
		<>
			<QueryClientProvider client={queryClient}>
				<BrowserRouter>
					<Page {...props} />
				</BrowserRouter>
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</>
	);
}

function Page(props: Props) {
	const { page } = props;
	const entityType = rootElement.getAttribute("data-entityType");
	const entityId = rootElement.getAttribute("data-entityId");

	switch (page) {
		case "login":
			return <Auth />;
		case "leads":
			return <Leads />;
		case "maps":
			return <Maps entityType={entityType} entityId={entityId} />;
		// Add other page components here as needed
		default:
			return (
				// We don't want the padding in production for now as the kendo layout already has it
				<div className="tw-p-4">
					<Dev />
				</div>
			); // Default fallback
	}
}

export default App;

interface Props {
	page?: string | null;
}
